var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"details"},[_c('article',{staticClass:"details-card"},[_c('header',{staticClass:"details-header"},[_c('h1',{directives:[{name:"t",rawName:"v-t",value:(_vm.prefix + 'title'),expression:"prefix + 'title'"}],staticClass:"details-header--title"}),_vm._v(" "),_c('p',{directives:[{name:"t",rawName:"v-t",value:(_vm.prefix + 'description'),expression:"prefix + 'description'"}],staticClass:"details-header--date"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fdf5f65","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Invoice/Paypal.vue
// module id = 158
// module chunks = 0